import { Package } from "lucide-react";
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "@/components/ui/card";

export function OnboardingPage() {
	return (
		<div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
			<Card className="max-w-md">
				<CardHeader className="text-center">
					<div className="w-12 h-12 bg-primary rounded-xl flex items-center justify-center mx-auto mb-4">
						<Package className="w-6 h-6 text-primary-foreground" />
					</div>
					<CardTitle>Welcome to Artify</CardTitle>
					<CardDescription>
						Customer onboarding flow coming soon
					</CardDescription>
				</CardHeader>
				<CardContent>
					<p className="text-sm text-gray-600 text-center">
						This page will contain the customer signup and onboarding process.
					</p>
				</CardContent>
			</Card>
		</div>
	);
}
